import React from "react";
import { Card, CardMedia, CardContent, Typography, Box, Button } from "@mui/material";
import { motion } from "framer-motion";

const cardData = [
  {

    title: "HIMALAYAS",
    description: "Experience the majestic beauty of the Himalayas, home to breathtaking peaks and serene landscapes.",
    image: "https://images.pexels.com/photos/1416900/pexels-photo-1416900.jpeg?cs=srgb&dl=pexels-rasikraj-1416900.jpg&fm=jpg",
  
  }
  ,
  {
    title: "ADVENTURE",
    description: "Embark on thrilling adventures with trekking, rock climbing, and river rafting experiences.",
    image: "https://imgd.aeplcdn.com/1280x720//n/cw/ec/164555/royalenfield-himalayan-450-right-side-view83.jpeg?isig=0&wm=3&q=75",
  },
  {
    title: "CULTURE & HERITAGE",
    description: "Discover the rich cultural heritage of the Himalayan region, from ancient monasteries to vibrant festivals.",
    image: "https://www.shutterstock.com/image-photo/himachal-pradesh-india-march-232018-600nw-1174967473.jpg",
  },
  {
    title: "FAIRS & FESTS",
    description: "Witness the vibrant fairs and festivals that celebrate the traditions and lifestyle of the Himalayas.",
    image: "https://himalayasdigital.com/wp-content/uploads/event-manager-uploads/event_banner/2023/12/TIPA.jpg",
  },
  {
    title: "FOOD",
    description: "Taste the authentic flavors of Himalayan cuisine, from momos to butter tea and more.",
    image: "https://www.saveur.com/uploads/2019/02/08/2XWKMWQ5IPAUTWYR7VUZIGBRGQ.jpg?auto=webp",
  },
  {
    title: "TREKKING",
    description: "Explore hidden trails and scenic landscapes with the best trekking experiences in the Himalayas.",
    image: "https://res.cloudinary.com/enchanting/q_80,f_auto,c_fit,w_640,h_480/exodus-web/2021/12/trekking-poles-himalaya.jpg",
  },
];

const Cardone = () => {
  return (
    <Box>
  
    <Typography variant="h2"className="cardoneheading">Heaven on Earth</Typography>


    <Box className="cards-container">

             

      {cardData.map((card, index) => (
        <motion.div
          key={index}
          className="card"
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 50 }} // Prevents flickering issue
          transition={{ duration: 0.8, delay: index * 0.2 }}
        >
          <Card className="custom-card">
            <CardMedia component="img" height="200" image={card.image} alt={card.title} />
            <CardContent>
              <Typography variant="h5" className="card-title">{card.title}</Typography>
              <Typography variant="body2" className="card-description">{card.description}</Typography>
            </CardContent>
          </Card>
        </motion.div>
      ))}
    </Box>
    </Box>
  );
};

export default Cardone;
